// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qc-paper {
  width: min(680px, calc(100vw - 32px));
}

.qc-paper .incyia-modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.qc-summary {
  display: flex;
  flex-direction: column;
  border: 1px solid #d7e6e3;
  border-radius: 10px;
  background: #f6fbfa;
  padding: 10px 14px;
}

.qc-summary header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
  margin-bottom: 6px;
}

.qc-summary-kind {
  flex-shrink: 0;
  color: #5f7484;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.qc-summary header strong {
  overflow: hidden;
  color: #0f2d3a;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qc-summary dl {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 6px 16px;
  margin: 0;
}

.qc-summary dl > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.qc-summary dt {
  color: #5f7484;
  font-size: 12px;
}

.qc-summary dd {
  margin: 0;
  color: #0f2d3a;
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.qc-summary dd.incyia-num {
  text-align: left;
}

.qc-summary .is-warn dd {
  color: #a35f00;
}

.qc-summary .is-danger dd {
  color: #b42318;
}

.qc-summary-muted,
.qc-summary-note {
  margin: 4px 0 0;
  color: #5f7484;
  font-size: 12px;
}

.qc-summary--plain {
  border: none;
  background: #f3faf8;
  border-radius: 10px;
  padding: 12px 14px;
}

.qc-summary--plain header {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.qc-summary--plain header strong,
.qc-summary--plain dt,
.qc-summary--plain dd,
.qc-summary--plain .qc-summary-note,
.qc-summary--plain .qc-summary-muted,
.qc-summary--plain .qc-summary-loading {
  font-size: 15px;
}

.qc-summary--plain dl {
  grid-template-columns: 1fr;
  gap: 8px;
}

.qc-summary--plain header strong {
  overflow: visible;
  font-size: 16px;
  text-overflow: unset;
  white-space: normal;
}

.qc-summary--plain dl > div {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2px;
}

.qc-summary--plain .is-warn,
.qc-summary--plain .is-danger {
  border-radius: 8px;
  padding: 6px 8px;
}

.qc-summary--plain .is-warn {
  background: #fff6ee;
}

.qc-summary--plain .is-danger {
  background: #fdf0ee;
}

.qc-summary--plain dd {
  font-weight: 600;
  text-align: left;
  white-space: normal;
}

.qc-summary-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 88px;
  margin: 4px 0 0;
  color: #5f7484;
  font-size: 13px;
}

.qc-error {
  border: 1px solid #f3c2bd;
  border-radius: 8px;
  background: #fdf0ee;
  color: #8f1d12;
  padding: 9px 12px;
  font-size: 13.5px;
}

.qc-field-error {
  display: block;
  margin-top: 4px;
  color: #b42318;
  font-size: 12.5px;
}

.qc-field-warn {
  display: block;
  margin-top: 4px;
  color: #a35f00;
  font-size: 12.5px;
}

.qc-locked {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 12px;
  border: 1px dashed #c8d7d9;
  border-radius: 8px;
  background: #f7fafa;
  color: #0f2d3a;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/quickCreate/QuickCreate.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".qc-paper {\n  width: min(680px, calc(100vw - 32px));\n}\n\n.qc-paper .incyia-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.qc-summary {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d7e6e3;\n  border-radius: 10px;\n  background: #f6fbfa;\n  padding: 10px 14px;\n}\n\n.qc-summary header {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n  margin-bottom: 6px;\n}\n\n.qc-summary-kind {\n  flex-shrink: 0;\n  color: #5f7484;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.qc-summary header strong {\n  overflow: hidden;\n  color: #0f2d3a;\n  font-size: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qc-summary dl {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n  gap: 6px 16px;\n  margin: 0;\n}\n\n.qc-summary dl > div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.qc-summary dt {\n  color: #5f7484;\n  font-size: 12px;\n}\n\n.qc-summary dd {\n  margin: 0;\n  color: #0f2d3a;\n  font-size: 14px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.qc-summary dd.incyia-num {\n  text-align: left;\n}\n\n.qc-summary .is-warn dd {\n  color: #a35f00;\n}\n\n.qc-summary .is-danger dd {\n  color: #b42318;\n}\n\n.qc-summary-muted,\n.qc-summary-note {\n  margin: 4px 0 0;\n  color: #5f7484;\n  font-size: 12px;\n}\n\n.qc-summary--plain {\n  border: none;\n  background: #f3faf8;\n  border-radius: 10px;\n  padding: 12px 14px;\n}\n\n.qc-summary--plain header {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.qc-summary--plain header strong,\n.qc-summary--plain dt,\n.qc-summary--plain dd,\n.qc-summary--plain .qc-summary-note,\n.qc-summary--plain .qc-summary-muted,\n.qc-summary--plain .qc-summary-loading {\n  font-size: 15px;\n}\n\n.qc-summary--plain dl {\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n.qc-summary--plain header strong {\n  overflow: visible;\n  font-size: 16px;\n  text-overflow: unset;\n  white-space: normal;\n}\n\n.qc-summary--plain dl > div {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 2px;\n}\n\n.qc-summary--plain .is-warn,\n.qc-summary--plain .is-danger {\n  border-radius: 8px;\n  padding: 6px 8px;\n}\n\n.qc-summary--plain .is-warn {\n  background: #fff6ee;\n}\n\n.qc-summary--plain .is-danger {\n  background: #fdf0ee;\n}\n\n.qc-summary--plain dd {\n  font-weight: 600;\n  text-align: left;\n  white-space: normal;\n}\n\n.qc-summary-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 88px;\n  margin: 4px 0 0;\n  color: #5f7484;\n  font-size: 13px;\n}\n\n.qc-error {\n  border: 1px solid #f3c2bd;\n  border-radius: 8px;\n  background: #fdf0ee;\n  color: #8f1d12;\n  padding: 9px 12px;\n  font-size: 13.5px;\n}\n\n.qc-field-error {\n  display: block;\n  margin-top: 4px;\n  color: #b42318;\n  font-size: 12.5px;\n}\n\n.qc-field-warn {\n  display: block;\n  margin-top: 4px;\n  color: #a35f00;\n  font-size: 12.5px;\n}\n\n.qc-locked {\n  display: flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 0 12px;\n  border: 1px dashed #c8d7d9;\n  border-radius: 8px;\n  background: #f7fafa;\n  color: #0f2d3a;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
